export function extractUserFriendlyErrorMessage(
  error: unknown,
  defaultMessage = "An unexpected error occurred.",
): string {
  if (isUserFacingError(error)) {
    return (error as UserFacingError).message;
  } else {
    return defaultMessage;
  }
}
export function extractErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  } else if (
    typeof error === "object" &&
    error !== null &&
    "message" in error &&
    typeof error.message === "string"
  ) {
    return error.message;
  } else if (typeof error === "string") {
    return error;
  }
  return "An unknown error occurred.";
}

export function isUserFacingError(error: unknown): boolean {
  return error instanceof UserFacingError;
}

export class UserFacingError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "UserFacingError";
  }
}
